
/* eslint-disable unused-imports/no-unused-vars */
import { API } from "../api";
import { TRIP_SHEET } from "../constants/url.constant";

export const GET_ALL_TRIP_SHEET = "GET_ALL_TRIP_SHEET";
export const DELETE_TRIP_SHEET = "DELETE_TRIP_SHEET";

export const createTripSheet = (data) => {
  return async (dispatch) => {
    return await API.post(TRIP_SHEET, data);
  };
};

export const getAllTripSheet = (params = {}) => {
  return async (dispatch) => {
    const res = await API.get(TRIP_SHEET, {
      params: params
    });
    dispatch({
      type: GET_ALL_TRIP_SHEET,
      payload: res
    });
    return res;
  };
};

export const getTripSheetById = (id) => {
  return async (dispatch) => {
    return await API.get(`${TRIP_SHEET}/${id}`);
  };
};

export const updateTripSheet = (id, data) => {
  return async (dispatch) => {
    return await API.put(`${TRIP_SHEET}/${id}`, data);
  };
};

export const removeTripSheet = (tripSheetId) => {
  return async (dispatch) => {
    const res = await API.delete(`${TRIP_SHEET}/${tripSheetId}`);
    dispatch({
      type: DELETE_TRIP_SHEET,
      payload: tripSheetId
    });
    return res;
  };
};

export const removeTripSheetBag = (tripSheetId, bagId) => {
  return async (dispatch) => {
    return await API.delete(`${TRIP_SHEET}/${tripSheetId}/${bagId}`);
  };
};

const initialState = {
  columns: [],
  data: [],
  totalRows: 0,
  order: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_TRIP_SHEET:
      return {
        ...state,
        columns: payload.columns,
        data: payload.rows,
        totalRows: payload.count
      };
    case DELETE_TRIP_SHEET:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        data: state.data.filter((tripsheet) => tripsheet.id !== payload)
      };
    default:
      return state;
  }
}
